import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import { Briefcase, FileText, Handshake, GraduationCap, Store } from 'lucide-react';

interface TypeBadgeProps {
  type: 'job' | 'tender' | 'jv' | 'training' | 'service_offer';
  className?: string;
}

const typeConfig = {
  job: { icon: Briefcase, color: 'bg-primary/10 text-primary border-primary/20' },
  tender: { icon: FileText, color: 'bg-secondary/10 text-secondary border-secondary/20' },
  jv: { icon: Handshake, color: 'bg-accent/10 text-accent-foreground border-accent/20' },
  training: { icon: GraduationCap, color: 'bg-muted text-muted-foreground border-muted-foreground/20' },
  service_offer: { icon: Store, color: 'bg-secondary/10 text-secondary border-secondary/20' },
};

export function TypeBadge({ type, className }: TypeBadgeProps) {
  const { t } = useTranslation();
  const { icon: Icon, color } = typeConfig[type];

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-semibold',
        color,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {t(`opportunities.types.${type}`)}
    </span>
  );
}